import {Link} from 'react-router-dom'
import styles from './SideBarMenu.module.css'
import {useDispatch, useSelector} from "react-redux";
import {
    ESCALATIONS_DISPLAY,
    HISTORY_DISPLAY,
    MAIN_DISPLAY,
    SILENCED_DISPLAY,
    STATS_DISPLAY,
    SILENCED_RULES_DISPLAY
} from "../../store/actions/DISPLAY_ACTIONS";
import {setSilenceRules} from "../../store/reducers/silenceRulesReducer";
import {setModalError} from "../../store/reducers/modalReducer";
import AlertService from "../../services/AlertService";
import {useEffect, useState} from "react";
import {authReducer} from "../../store/reducers/authReducer";


const SideBarMenu = () => {
    const dispatch = useDispatch()
    const isOpenedSideBar = useSelector(state => state.hiddenMenu.isOpenedSideBar)
    const activeMenuItem = useSelector(state => state.setDisplay.display)
    const silenceRules = useSelector(state => state.setSilenceRules.rules)
    const myMail = useSelector(state => state.authReducer.user.userEmail)
    const [commonRulesCount, setCommonRulesCount] = useState(0)
    const [myRulesCount, setMyRulesCount] = useState(0)

    useEffect(() => {
        setCommonRulesCount(silenceRules.length)
        const myRules = silenceRules.filter(rule => rule.author === myMail)
        setMyRulesCount(myRules.length)
    }, [silenceRules])

    return (
        <div className={isOpenedSideBar ? `${styles.menu}` : `${styles.menu} ${styles.menu_closed}`}>
            <ul className={styles.menuList}>
                <li key="alerts" className={styles.menuItem}>
                    <Link className={activeMenuItem === MAIN_DISPLAY ? `${styles.menuButton} ${styles.menuButtonActive}` : `${styles.menuButton}`}
                        to="/main"
                        onClick={e => {
                    }}> Alerts </Link>
                </li>
                <li key="silenced" className={styles.menuItem}>
                    <Link className={activeMenuItem === SILENCED_DISPLAY ? `${styles.menuButton} ${styles.menuButtonActive}` : `${styles.menuButton}`}
                        to="/silence_alerts"
                        onClick={e => {
                    }}> Silenced Alerts</Link>
                </li>
                <li key="silence rules" className={styles.menuItem}>
                    <Link className={activeMenuItem === SILENCED_RULES_DISPLAY ? `${styles.menuButton} ${styles.menuButtonActive}` : `${styles.menuButton}`}
                        to="/silence_rules"> Silence Rules ({myRulesCount}/{commonRulesCount}) </Link>
                </li>
                <li key="history" className={styles.menuItem}>
                    <Link className={activeMenuItem === HISTORY_DISPLAY ? `${styles.menuButton} ${styles.menuButtonActive}` : `${styles.menuButton}`}
                        to={"/history"}
                        onClick={e => {
                    }}> History </Link>
                </li>
                <li key="stats" className={styles.menuItem}>
                    <Link
                        className={activeMenuItem === STATS_DISPLAY ? `${styles.menuButton} ${styles.menuButtonActive}` : `${styles.menuButton}`}
                        to="/stat"
                        onClick={e => {
                    }}> Stats </Link>
                </li>
                <li key="escalations" className={styles.menuItem}>
                    <Link className={activeMenuItem === ESCALATIONS_DISPLAY ? `${styles.menuButton} ${styles.menuButtonActive}` : `${styles.menuButton}`}
                        to="/escalations"
                        onClick={e => {
                    }}> Escalations </Link>
                </li>
            </ul>
        </div>
    );
};

export default SideBarMenu;